import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';
import { useAppTargetId } from '../../store/projectStore';

const WEBPAGE_DETAILS_STALE_TIME_MS = 30_000;

export const getWebpageDetailsQueryKey = ({
  appTargetId,
  webpageId,
}: {
  appTargetId: string | undefined;
  webpageId: string | null | undefined;
}) => ['webpage-details', appTargetId, webpageId] as const;

export function useWebpageDetails({
  webpageId,
  enabled = true,
}: {
  webpageId: string | null | undefined;
  enabled?: boolean;
}) {
  const appTargetId = useAppTargetId();

  return useQuery({
    queryKey: getWebpageDetailsQueryKey({ appTargetId, webpageId }),
    queryFn: async () => {
      if (!webpageId) {
        throw new Error('No valid webpage ID found');
      }

      const webpage = await terraProxyApiClient.getWebPageById(webpageId);

      if (!webpage) {
        throw new Error('Webpage not found');
      }

      return webpage;
    },
    enabled: enabled && !!webpageId && !!appTargetId,
    refetchOnWindowFocus: false,
    staleTime: WEBPAGE_DETAILS_STALE_TIME_MS,
  });
}
